import { useDeleteAccountRequests } from "../../info-technology-process/delete-user-account/hooks";
import { useEPRCodeRequests } from "../../info-technology-process/epr-process/hooks/use-epr-code-requests";
import { useCodeProcessRequests } from "../../info-technology-process/code-process/hooks";
import { useRepairToolsRequests } from "../../info-technology-process/repair-tools/hooks";
import { useDemandForSuppliesRequests } from "../../info-technology-process/demand-for-supplies/hooks/use-demand-for-supplies-requests";

export const useITDepartmentRequests = () => {
  const {
    isLoading: loading1,
    deleteAccountRequests,
    deleteAccountMyRequests,
  } = useDeleteAccountRequests();
  const {
    isLoading: loading2,
    eprCodeRequests,
    eprCodeMyRequests,
  } = useEPRCodeRequests();
  const {
    isLoading: loading3,
    codeProcessRequests,
    codeProcessMyRequests,
  } = useCodeProcessRequests();
  const {
    isLoading: loading4,
    repairToolsRequests,
    repairToolsMyRequests,
  } = useRepairToolsRequests();
  const {
    isLoading: loading5,
    demandForSuppliesRequests,
    demandForSuppliesMyRequests,
  } = useDemandForSuppliesRequests();

  const isLoading = loading1 || loading2 || loading3 || loading4 || loading5;

  const allITDepartmentRequests = [
    ...deleteAccountRequests,
    ...eprCodeRequests,
    ...codeProcessRequests,
    ...repairToolsRequests,
    ...demandForSuppliesRequests,
  ];
  const allITDepartmentMyRequests = [
    ...deleteAccountMyRequests,
    ...eprCodeMyRequests,
    ...codeProcessMyRequests,
    ...repairToolsMyRequests,
    ...demandForSuppliesMyRequests,
  ];

  return {
    isLoading,
    allITDepartmentRequests,
    allITDepartmentMyRequests,
  };
};
